import {
  GET_LABREQUESTREQ_FAIL,
  GET_LABREQUESTREQ_SUCCESS,
  GET_LABREQUESTREQS_FAIL,
  GET_LABREQUESTREQS_SUCCESS,
  ADD_LABREQUESTREQ_SUCCESS,
  ADD_LABREQUESTREQ_FAIL,
  UPDATE_LABREQUESTREQ_SUCCESS,
  UPDATE_LABREQUESTREQ_FAIL,
  DELETE_LABREQUESTREQ_SUCCESS,
  DELETE_LABREQUESTREQ_FAIL,  
  SET_STATE_LABREQUESTREQ
} from "./actionTypes";

const INIT_STATE = {
  labRequestReqs: [],
  labRequestReq: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestReqs = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTREQS_SUCCESS:
      return {
        ...state,
        labRequestReqs: action.payload.labRequestReqs,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTREQ:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTREQS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTREQ_SUCCESS:
      return {
        ...state,
        labRequestReqs: [...state.labRequestReqs, action.payload],
      };

    case ADD_LABREQUESTREQ_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTREQ_SUCCESS:
      return {
        ...state,
        labRequestReqs: state.labRequestReqs.map(labRequestReq =>
          labRequestReq.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestReq }
            : labRequestReq
        ),
      };

    case UPDATE_LABREQUESTREQ_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTREQ_SUCCESS:
      return {
        ...state,
        labRequestReqs: state.labRequestReqs.filter(
          labRequestReq => labRequestReq.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTREQ_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTREQ_SUCCESS:
      return {
        ...state,
        labRequestReq: action.payload,
      };

    case GET_LABREQUESTREQ_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestReqs;
